import Logger from '../util/Logger';

const REDUX_STATE = 'redux-state';

export default {

  /**
   * Save the redux store state to session storage
   *
   * @param store
   */
  persist: (store) => {
//     store.subscribe(() => {
//       Logger.info('Persisting Redux state into session-storage');
//       if (window.sessionStorage) {
//         window.sessionStorage.setItem(REDUX_STATE, JSON.stringify(store.getState()));
//       }
//     });
  },

  /**
   * Get the persisted state if any exists
   * @type {{}}
   */
  get: () => {
    if (window.sessionStorage) {
      const persisted = window.sessionStorage.getItem(REDUX_STATE);
      if (persisted) {
        Logger.info('Grabbing Redux state from session storage');
        return JSON.parse(persisted) || {};
      } else {
        return {};
      }
    } else {
      return {};
    }
  },

  /**
   * Clear the store
   */
  clear: () => {
    if (window.sessionStorage) {
      window.sessionStorage.removeItem(REDUX_STATE);
    }
  }
};

